// src/stone/illustrations/DoubleCardsIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var DoubleCardsIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 64 64",
    ...props,
    children: [
      /* @__PURE__ */ jsx("rect", { width: 64, height: 64, fill: "#E8FEF3", rx: 8 }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "M46.09 38.842 20.772 49.55a3.74 3.74 0 0 1-4.861-1.927L9.228 32.528a3.595 3.595 0 0 1 1.89-4.783l25.319-10.709a3.74 3.74 0 0 1 4.86 1.927l6.684 15.096a3.595 3.595 0 0 1-1.89 4.783"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "m21.565 33.448 1.463 15.098-2.31.948a4.02 4.02 0 0 1-2.641.14z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "m17.716 49.036-.024-.004a.13.13 0 0 1-.097-.152l3.88-15.46a.13.13 0 0 1 .159-.09c.07.017.113.085.097.152l-3.88 15.46a.13.13 0 0 1-.135.094"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M17.057 41.44a.125.125 0 0 1-.145-.07.12.12 0 0 1 .063-.162l17.718-7.53a.124.124 0 0 1 .162.064.12.12 0 0 1-.063.161l-17.718 7.53zM24.962 40.377a.124.124 0 0 1-.145-.07.12.12 0 0 1 .063-.161l7.636-3.244a.124.124 0 0 1 .162.064.12.12 0 0 1-.063.161l-7.636 3.244zM17.919 43.363a.125.125 0 0 1-.146-.07.12.12 0 0 1 .064-.161l5.688-2.417a.124.124 0 0 1 .162.065.12.12 0 0 1-.063.16l-5.688 2.417zM41.708 19.672 9.503 33.32l1.848 4.178 32.205-13.646z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCFCFC",
          stroke: "#FCFCFC",
          d: "m38.72 21.478-.073 3.884-3.17 1.342.072-3.885zM40.835 20.58l-.074 3.872-.167.07.073-3.871z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "m51.136 27.281-27.933 2.385c-2.057.175-3.577 1.954-3.395 3.974l1.48 16.454c.183 2.019 1.997 3.513 4.054 3.338l27.934-2.385c2.057-.175 3.577-1.954 3.395-3.974L55.19 30.62c-.182-2.019-1.997-3.514-4.054-3.338"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#E8E9EA",
          d: "m52.34 37.949-3.623.31a.54.54 0 0 0-.498.582l.218 2.414a.546.546 0 0 0 .594.49l3.623-.31a.54.54 0 0 0 .498-.583l-.218-2.414a.546.546 0 0 0-.594-.49"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCFCFC",
          d: "m31.76 35.812.596-.053a.04.04 0 0 0 .032-.01l.01-.015.003-.016-.146-1.615c-.042-.458.166-.718.56-.752.396-.034.644.19.686.647l.145 1.615a.04.04 0 0 0 .017.03.04.04 0 0 0 .034.007l.596-.053a.04.04 0 0 0 .032-.01.04.04 0 0 0 .013-.031l-.145-1.611c-.063-.692-.51-1.263-1.424-1.185-.915.079-1.255.723-1.194 1.407l.146 1.61a.044.044 0 0 0 .039.035M27.666 36.2q.215-.009.416-.084a.06.06 0 0 0 .03-.049l-.045-.483c-.002-.027-.016-.042-.053-.04s-.112.025-.183.035c-.256.022-.377-.062-.397-.283l-.126-1.36.55-.045a.05.05 0 0 0 .03-.017.05.05 0 0 0 .01-.034l-.047-.527a.05.05 0 0 0-.017-.03.05.05 0 0 0-.033-.011l-.57.048-.042-.456c-.004-.05-.028-.068-.063-.067l-.562.048a.06.06 0 0 0-.05.021.057.057 0 0 0-.01.053l.224 2.51c.063.602.43.814.938.77M25.279 36.435c.67-.056 1.113-.5 1.064-1.03-.05-.59-.473-.725-1.025-.798l-.276-.034c-.205-.025-.324-.115-.343-.272-.015-.199.18-.332.467-.357.25-.01.501.03.736.12a.06.06 0 0 0 .048-.045l.073-.406c.016-.055.01-.067-.029-.084a1.8 1.8 0 0 0-.884-.119c-.678.058-1.115.482-1.068.992.044.483.447.717.999.785l.28.034c.224.027.356.1.379.29.024.191-.119.364-.473.395a2.6 2.6 0 0 1-.912-.121c-.034.003-.045.021-.052.075l-.042.337c-.014.072.012.115.059.13.323.1.662.137.999.108M29.77 35.478c-.438.037-.867-.252-.919-.858-.05-.607.317-.957.754-.994s.86.244.919.857c.058.613-.313.959-.755.995m.052.588c.874-.075 1.453-.77 1.374-1.65a1.5 1.5 0 0 0-.347-.79 1.545 1.545 0 0 0-1.61-.468 1.5 1.5 0 0 0-.728.478 1.47 1.47 0 0 0-.165 1.64c.14.26.355.473.618.613.262.14.56.202.858.177M37.445 33.856c-.082-.902-.664-1.438-1.509-1.363a1.5 1.5 0 0 0-1.022.533 1.44 1.44 0 0 0-.312 1.095c.093.976.838 1.474 1.587 1.41.63-.052.97-.327 1.167-.641.038-.062.045-.087.044-.104 0-.016-.013-.028-.054-.057l-.283-.203c-.067-.048-.09-.063-.11-.06-.022.002-.032.015-.045.04a.91.91 0 0 1-.732.437c-.424.036-.734-.224-.847-.678l1.92-.162c.129-.022.208-.07.196-.247m-1.483-.8a.68.68 0 0 1 .507.128.66.66 0 0 1 .255.449l-1.441.123c.05-.368.277-.67.68-.7"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F1BD38",
          d: "m49.3 54-1.204-3.268-3.33-1.179 3.33-1.18 1.201-3.27 1.203 3.269 3.33 1.178-3.33 1.18zM34.687 19.024l-.958-2.327-2.436-.762 2.37-.94.778-2.392.958 2.327 2.435.762-2.37.94z"
        }
      )
    ]
  }
);
var DoubleCardsIllustration_default = DoubleCardsIllustration;

export {
  DoubleCardsIllustration_default
};
